import React from "react";
import PropTypes from "prop-types";

const CustomStaticRangeLabelContent = props => {
  const { text } = props;

  return <span>{text}</span>;
};

CustomStaticRangeLabelContent.propTypes = {
  text: PropTypes.string,
};

export default CustomStaticRangeLabelContent;
